<script>
  export default {
    created() {
      this.getDefaults()

    },
    data() {
      return {
        state: null
      }
    },
    methods: {
      switched() {
        this.$http.post('/api/v1/app/merchant/settings/withdraws', { withdraw: { active: this.state }}).then(response => {
          this.notifySuccess('Batch Withdraw setting successfully updated')
        }, response => {
          this.notifyError('Something went wrong. Pay settins not updated')
          this.state = !this.state
        })
      },
      getDefaults() {
        this.$http.get('/api/v1/app/merchant/settings/withdraws').then(response => {
          this.state = response.body.active
        })

      }
    }
  }
</script>

<template>
  <div>
    Allow Daily Batch Withdraw balance:<br>
    <!-- Switch -->
    <div class="switch">
      <label>
        Off
        <input type="checkbox" @change='switched' v-model='state'>
        <span class="lever"></span>
        On
      </label>
    </div>
  </div>
</template>

